import { useEffect, useMemo, useState } from 'react';
import { useFilterConfigs } from '../../../../../../../hooks/useFilterConfigs';
import { useFilters } from '../../../../../../../hooks/useFilters';
import type { Filter } from '../../../../../../../stores/filters';

const useExpressionTypeSelector = (filterName: string, onExpressionTypeChange?: (value: string) => void) => {
  const { filters } = useFilters();
  const { filterConfigs } = useFilterConfigs();

  const filterConfig = filterConfigs.find((item) => item.filterName === filterName);
  const isRangeSliderType = filterConfig?.type === 'range_slider';

  const filtersList = useMemo(() => (filters ? (Object.values(filters) as Array<Filter>) : []), [filters]);
  const filter = filtersList.find((filter) => filter.filterName === filterName);

  const [initialToggleValue, setInitialToggleValue] = useState<string>(filter?.expressionType || 'target');

  useEffect(() => {
    const filter = filters?.[filterName];
    const expressionType = filter?.expressionType;
    const expression = filter?.expression;

    if (isRangeSliderType && expression?.startsWith('not')) {
      setInitialToggleValue('block');
    } else if (expressionType) {
      setInitialToggleValue(expressionType);
    }
  }, [filterName, filters]);

  const handleRadioChange = (value: 'target' | 'block') => {
    setInitialToggleValue(value);

    if (onExpressionTypeChange) {
      onExpressionTypeChange(value);
    }
  };

  return { initialToggleValue, handleRadioChange };
};

export default useExpressionTypeSelector;
